<template>
    <div class="hello">
        <h1>Frequently Asked Questions</h1>

        <div class="row">
            <div class="col-md-6">

        <BR/>
            <Faq-Item>
                <div slot="question">How often is information updated?</div>
                Ranking information is fetched each Sunday (not at exactly the same time but usually around noon USA ET) for the top 75,000 users (with score of at least 500 points) and top 750 fellowships per server.
                This means the player score and fellowship score will be displayed as what it was the previous Sunday.  Information about boosts and other detailed user level info which comes from analyzing a players city.  This is refreshed whenever someone views your fellowship page and the citymaps are older than 10 days (or someone manually refreshes it).
                It can also be refreshed for individual users by pressing the <i class="fas fa-sync"></i> icon from the fellowship detail page. Please don't go overboard and refresh your users every every day it's really unnecessary and adds a lot of load to our servers.
            </Faq-Item>
            <Faq-Item>
              <div slot="question">Why isn't my user on elvenstats?</div>
              You have to rank in the top 75,000 on your server.  You also get added if you are a member of a fellowship that is in the top 750 and you press the refresh members button on the fellowship page.
              One caveat here though, I don't think your score history will not be snapshotted each week until you reach the top 75000.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">Why is my data wrong?</div>
               Please read the the FAQs.  In particular the two above and the 4 below. Highly suspect it's answered here.  If you think it's a bug, please <router-link to="/contact">contact us</router-link> and we'll look into it.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">How are boosts determined?</div>
                <strong>UPDATED March 17, 2018</strong> We use the players location on the map and apply an algorithm.  The province grid has a pattern which
                allows us to determine the boosts.  Originally, our algorithm analyzed the number / type of manufacturies a player had.  This proved to be
                inaccurate for about 1.5% of users so we scraped that in favor of the map based approach which is 100% accurate.  There may be a few very small number
                of players out there with incorrect boost information.  A refresh of the users city will resolve this permanently.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">I added one of the brand new buildings and my production stats didn't update?</div>
                There is a lag between when a new building is released in the game and when it elvenstats knows about it.  This is particularly the case
                with event buildings. In that period in between our system might not know about that building. If you need to have better estimates, elvenarchitect does
                a better job of keeping their database up to date and they provide similar production stats when you import into their system.
                You can have a sense for when we last updated our building database by looking at the release notes on the homepage.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">How do you calculate the number of goods that are made for each user?</div>
                A fair bit of math.  First, we analyze the members city and from that we get the number and level of each manufactory type.  From this, we can determine how much of each good each member produces.
                We normalize our data by calculating what a user would generate if they did 1x24 hour production (or in the case of LVL 24+, 1x9h per day). We then
                multiply this times the users boost % + their mountain hall boost percentage.  Finally we multiply another scaling factor based on the number
                of collections a user makes per day.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">How do you know what each members boost percentages are?</div>
                <B>UPDATED: April 2, 2018:</B> We <u>don't</u>, the default values are intelligent guesses.  We suggest you ask your fellowship
                members for the actual values for even better accuracy. The default values were selected by taking an average of the 2000+
                user supplied boost percentages for each chapter. We wanted to have a reasonably
                accurate starting point for mages to work off of in the absense of perfect data which cannot always be obtained by
                members.  We do strongly encourage you to ask your fellowship members to get a more accurate view of the data.
                Prior to April 2nd, our default values were much higher then they are today.
            </Faq-Item>

            <Faq-Item anchor="collectionsPerDay">
                <div slot="question">What is Collections Per Day (as shown on the Fellowship Pages)?</div>
                It is the number of times that a user "collects" their goods and then sets them again. The more times you collect
                per day the more goods you'll generate.
                <table class="table table-striped table-condensed table-bordered">
                    <thead>
                    <tr>
                        <td>Collections Per Day</td>
                        <td>Produced</td>
                        <td>Example for Marble</td>
                        <td>Player Profile</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr><td> 1/day</td><td> 1x24h</td><td>1 Admirable Alter</td><td>Casual, logs in once a day</td></tr>
                    <tr><td>2/day</td><td> 2x9h</td><td>2 x Decorative Pillars</td><td>Once in morning and once at night</td></tr>
                    <tr><td>3/day</td><td>1x3h + 2x9h</td><td>1 Marble Mosaic, and 2 Decorative Pillars</td><td>Logs in before work, after work, and before bed</td></tr>
                    <tr><td>4/day</td><td>3x3h + 1x9h</td><td>3 Marble Mosaics, and 1 Decorative Pillar</td><td>Has freedom to login throughout the day</td></tr>
                    <tr><td>5/day</td><td>4x3h + 1x9h</td><td>4 Marble Mosaics, and 1 Decorative Pillar</td><td>Has freedom to login throughout the day</td></tr>
                    <tr><td>6/day</td><td>5x3h + 1x9h</td><td>5 Marble Mosaics, and 1 Decorative Pillar</td><td>Person that never sleeps or only sleeps for 2:59 minutes at a time.</td></tr>
                    </tbody>
                </table>
                <small>A player that collects 5 times a day will produce 1.85x (almost double) what a player that collects once a day will.</small>

            </Faq-Item>
            <Faq-Item>
                <div slot="question">Why did you make this site?</div>
                I built a similar site for a commercial purpose and saw lots of opportunities to reuse the existing codebase for a
                fun purpose.  I also thought these tools would help people become better players and would reduce some of the mundane tasks
                that mages do in the game to keep their respective ships sailing smoothly.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">How is the fellowship tournament score computed?</div>
                <strong>Updated March 17, 2018: </strong> The fellowship tournament score is the sum of all the individual players who were in the fellowship
                at the very end of the fellowship.  So, if a player was in Fellowship A at the start of the tournament and contributed 1000 points to Fellowship A,
                then midway through the tournament (on like Friday) joined Fellowship B and contributed 500 points to the tournament.  Fellowship B would be computed
                such that all 1500 points from that player went to them.  Prior to March 17th, 2018, we based it on where members were on Sunday morning, we changed this
                based on feedback from the user base that it's fairly common for people to change fellowships shortly after tournament end.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">Can you track how many visits and inventory of goods each player has?</div>
                No, we do not have access to any private information.  We can only see what other players on the server can see.  So, while this means we can't
                solve all your tracking needs.  We hope you'll find solace in knowing we don't have access to private information such as this.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">What servers are currently supported?</div>
                <br-simple-table :items="servers"></br-simple-table>
            </Faq-Item>

            <Faq-Item>
                <div slot="question">Why do some servers have more data then others?</div>
                The table above shows all the servers currently being tracked and when they were added.  Servers that have been tracked longer will have more score histories.
                Additional servers will be added once requested.  <router-link to="/contact">Get in touch</router-link> and we'll make it happen.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">Why do the percentages of goods produced seem inaccurate?</div>
                First, let me explain how it's calculated.  1. We only look at the boosted manufactories.  2. By default, we are estimating
                what each members boost percentages are.  3.  We're also assuming all members are equally active.  In reality,
                not all members will make and collect goods several times a day.  A player that is doing 3x3hr builds + 1x9hr per day will produce almost 2x
                the number of goods as a member with the same manufactories that only does a single 24-hour build per day. On the fellowship page
                you can edit the boost percentages and frequency a user collects per day. One of your mages should do this periodically by surveying
                the users to get an estimate and update it.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">The fellowship page isn't showing a new member or it's showing an old one?</div>
                Click the "Refresh Member List" Button above the Member Goods Production table.  This will fetch your current fellowship listing and add/remove members as appropriate.
                It will also update the roles and current scores for all members.
            </Faq-Item>

            <Faq-Item>
                <div slot="question">We promoted a member to Ambassador/Mage/Archmage but the fellowship page hasn't updated?</div>
                Click the "Refresh Member List" Button above the Member Goods Production table.  It will update the roles.
            </Faq-Item>

            <Faq-Item anchor="boostCombinations">
                <div slot="question">What are valid boost combinations?</div>
                On the Fellowship page, we provide suggestions for the boosts your fellowship needs.  These are simply boosts you have less then 28% of.
                If you're low on 3 boosts, there is a very good chance that you will not be able to find just a single candidate that can provide all of them.
                There are only 9 boost combinations and they are: <br/>
                <elv-boost-icon boost="marble" width="24"/><elv-boost-icon boost="crystal" width="24"/><elv-boost-icon boost="elixir" width="24"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <elv-boost-icon boost="marble" width="24"/><elv-boost-icon boost="crystal" width="24"/><elv-boost-icon boost="gems" width="24"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <elv-boost-icon boost="marble" width="24"/><elv-boost-icon boost="silk" width="24"/><elv-boost-icon boost="gems" width="24"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <elv-boost-icon boost="planks" width="24"/><elv-boost-icon boost="silk" width="24"/><elv-boost-icon boost="gems" width="24"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <elv-boost-icon boost="planks" width="24"/><elv-boost-icon boost="silk" width="24"/><elv-boost-icon boost="magic_dust" width="24"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <elv-boost-icon boost="planks" width="24"/><elv-boost-icon boost="scrolls" width="24"/><elv-boost-icon boost="magic_dust" width="24"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <elv-boost-icon boost="steel" width="24"/><elv-boost-icon boost="scrolls" width="24"/><elv-boost-icon boost="magic_dust" width="24"/>&nbsp;&nbsp;&nbsp;&nbsp;
                <elv-boost-icon boost="steel" width="24"/><elv-boost-icon boost="scrolls" width="24"/><elv-boost-icon boost="elixir" width="24"/>&nbsp; or &nbsp;
                <elv-boost-icon boost="steel" width="24"/><elv-boost-icon boost="crystal" width="24"/><elv-boost-icon boost="elixir" width="24"/>
            </Faq-Item>

            <Faq-Item>
                <div slot="question">Are you affiliated with ElvenArchitect?</div>
                Not in any official capacity, though much of the reporting code used on our site was greatly inspired
                and in some cases duplicated (with permission) from them.  We think ElvenArchitect/Konniver are the Bee's Knees!
            </Faq-Item>

            <Faq-Item>
                <div slot="question">What languages are supported? Can I help with translations?</div>
                Click on the flag icon in upper right hand corner for all the supported languages right now.  Translations on this site are
                provided by volunteers.  Some languages have more of the site translated then others.  If you'd like to contribute, get in touch with us.
            </Faq-Item>
            <Faq-Item>
                <div slot="question">I just changed fellowships, but the "My Fellowship" link brings me to my old fellowship</div>
                First refresh your user, by going to your user page and click the <i class="fas fa-sync"></i> icon at the bottom of the page.
                Then, reload the page by clicking on the browsers refresh button (or opening the site in a new tab).
            </Faq-Item>
            <Faq-Item>
                <div slot="question">How do you get the information / What information do you have?</div>
                We retrieve information using the same api the game uses.  We access the api using a player created on each server/world.
                This player is aptly named 'elvenstats'. Therefore, we only know things that any other non-fellowship member could know
                about you.  We look at the ranking lists and visit your city. From the ranking list, we can learn your score and we snapshot
                it every week so we can generate weekly reports. We do the same for the tournament list, and fellowship ranking lists.
                From the fellowship member lists, we can learn your role within the fellowship (Fellow, Ambassador, Mage, Archmage).
                From visiting your city, we can determine what buildings you have which allows us to calculate how much you produce.
                We also know the grid location of each building.  Combining the building data and grid data we are able to pass this information on to ElvenArchitect
                so it can be imported in one click. We can also determine where you are on the world map and by doing some clever math, we can determine your
                boosts.  We also know what chapter your in, However, we do not know your progress within the chapter.
                <br/><br>
                Just in case there is any question, we want to be very clear about the information WE DO NOT HAVE:
                <ul style="margin-left: 40px;">
                    <li>We <strong>DO NOT</strong> know your name, your email address, address, or any personally identifiable information.</li>
                    <li>We <strong>DO NOT</strong> know when you login, where you login from, or how often you login, etc.</li>
                    <li>We <strong>DO NOT</strong> know how money you've spent nor do we have your credit card information.</li>
                    <li>We <strong>DO NOT</strong> know how many goods you have in your inventory. Nor do we know your troop levels, number of spells, etc.</li>
                    <li>We <strong>DO NOT</strong> know who visits you and provides neighborly help.</li>
                </ul>

                <P>See Also: <router-link to="/privacy-policy">Privacy Policy</router-link></P>
            </Faq-Item>

            <Faq-Item>
                <div slot="question"> Are you affiliated with InnoGames? </div>
                No.  This website is in no way affiliated with InnoGames.  It was built by a long-term player of Elvenar.
                Elvenar is a trademark of InnoGames GmbH. All original photos, images and articles are copyright to their
                respective owners and no copyright infringement is intended.
            </Faq-Item>


            </div>
        </div>

        <mail-chimp-signup></mail-chimp-signup>
        <br/><br/>



    </div>
</template>

<script>
    import Vue from "vue";
    import FaqItem from "@/components/Faq-Item";
    import MailChimpSignup from "@/components/MailChimpSignup"
    import BrSimpleTable from "@/components/BRSimpleTable"
    import axios from 'axios'
    import ElvBoostIcon from "@/components/ElvBoostIcon"
    // Vue.use(FaqItem);

    export default {
        name: 'Faq',
        components: {
            ElvBoostIcon,
            BrSimpleTable,
            MailChimpSignup,
            FaqItem },
        data () {
            return {
                servers: [],
            }
        },
        created() {
            axios.get('/api/servers/history').then( (response) => {
                console.log(response.data)
                this.servers = response.data;
                this.servers = _.sortBy(_.map(response.data, function(server) {
                    return {
                        Server: server.server,
                        "Tracking Began On": moment(server.createdAt).format("YYYY-MM-DD"),
                        "Days Since": moment().diff( moment(server.createdAt), "days")
                    };
                }), "Server");
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .faqtable {
    }
    table.table thead th {
        font-weight: bold;
    }
    table.table tbody td, table.table tbody tr, table.table thead tr {

        height: 24px;
    }

</style>



// WEBPACK FOOTER //
// src/views/Faq.vue